export default {
  button: {
    padding: '10px 12px',
    color: (theme) => theme.palette.grays.gray700,
    border: (theme) => ` 1px solid ${theme.palette.grays.gray300}`,
    fontWeight: 700,
    fontSize: '0.875rem',
    flex: 1,
    height: '40px',
    '&:hover': {
      backgroundColor: (theme) => theme.palette.blues.lightestBlue,
    },
    '&.Mui-selected': {
      color: (theme) => theme.palette.blues.primaryBlue600,
      border: (theme) => ` 1px solid ${theme.palette.blues.primaryBlue600}`,
      backgroundColor: (theme) => theme.palette.blues.primaryBlue200,
      '&:hover': {
        backgroundColor: (theme) => theme.palette.blues.lightestBlue,
      },
      '&:not(:first-of-type)': {
        border: (theme) => ` 1px solid ${theme.palette.blues.primaryBlue600}`,
      },
    },
    '&:disabled': {
      cursor: 'default',
      opacity: '0.5',
    },
  },
  group: {
    minWidth: '200px',
    width: '100%',
  },
};
